__turbopack_context__.v({
  "balance": "NFTImage-module-scss-module__OsUXwq__balance",
  "balanceBigger": "NFTImage-module-scss-module__OsUXwq__balanceBigger",
  "balanceInline": "NFTImage-module-scss-module__OsUXwq__balanceInline",
  "height300": "NFTImage-module-scss-module__OsUXwq__height300",
  "height650": "NFTImage-module-scss-module__OsUXwq__height650",
  "heightFull": "NFTImage-module-scss-module__OsUXwq__heightFull",
  "imageWrapper": "NFTImage-module-scss-module__OsUXwq__imageWrapper",
  "nftAnimation": "NFTImage-module-scss-module__OsUXwq__nftAnimation",
  "transparentBG": "NFTImage-module-scss-module__OsUXwq__transparentBG",
});
